import React 			from 'react'
import renderHTML 		from 'react-render-html'

import BubbleStack 		from '../../../bubble-stack'

import {
	mapImagesToBubbleStack
} from '../../../../lib/_helpers'

import Section 			from '../section'

export default (props) => {
	const {
		bubbles
	} = props

	return <Section
		type="bubbleImages"
		>
		{ bubbles && bubbles.length > 0 ? <BubbleStack
			//ratio={ 0.75 }
			images={ mapImagesToBubbleStack(bubbles) }
			/> : null }
	</Section>
}